import { organisationPermissions } from './organisationPermissions'
import { userPermissions } from './userPermissions'

export const allPermissions = [...organisationPermissions, ...userPermissions] as const
